module.exports = __webpack_public_path__ + "static/media/background1.a11a8a51.jpg";